import styled from "@emotion/styled";

type Props = {
  ifCurrentUser?: boolean;
  ifBorderColor?: string;
  ifFontColor?: string;
  isExpired?: boolean;
  ifNoBorderBottom?: boolean;
  arrowHeight?: number;
};

export const MessageList = styled.ul`
  padding: 10px 0;
  width: 100%;
  margin: 0 auto;
  list-style: none;
  flex-grow: 1;
  overflow: auto;
  overflow-scrolling: touch;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const MessageContainer = styled.div<Props>`
  padding: 5px 10px;
  ${({ ifNoBorderBottom }) =>
    ifNoBorderBottom ? `border-bottom: 0px solid;` : `border-bottom: 1px solid;`};
  border-color: #555;
  position: relative;
  ${({ ifCurrentUser }) => ifCurrentUser && `background: #272E3Bb0`}
`;

export const ThreadMessageContainer = styled.div<Props>`
  padding-left: 35px !important;
  padding: 5px 10px;
  border-top: 0px;
  ${({ ifNoBorderBottom }) =>
    ifNoBorderBottom ? `border-bottom: 0px solid;` : `border-bottom: 1px solid;`};
  border-color: #555;
  position: relative;
  ${({ ifCurrentUser }) => ifCurrentUser && `background: #272E3Bb0`}
`;

export const MessageOptionContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

type MessageOptionWrapperProps = {
  active?: boolean;
};
// use active as opacity
// if active is true, opacity is 1, else 0
export const MessageOptionWrapper = styled.div<MessageOptionWrapperProps>`
  opacity: ${({ active }) => (active ? 1 : 0)};
  top: 15px;
  position: absolute;
  right: 0;
  z-index: 1;
  padding: 0 14px 0 32px;
`;

export const MessageOptionButtonGroup = styled.div`
  box-shadow: 0 0 0 1px #555;
  display: grid;
  grid-auto-flow: column;
  box-sizing: border-box;
  border-radius: 2px;
  align-items: center;
  justify-content: flex-start;
  user-select: none;
  position: relative;
  overflow: hidden;
`;

export const MessageOptionButton = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  height: 20px;
  margin: 2px;
  min-width: 20px;
  -webkit-box-flex: 0;
  color: var(--interactive-normal);
  cursor: pointer;
  position: relative;
`;

export const Messages = styled.li<Props>`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
`;

export const RepliedMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: center;
  font-size: 0.875rem;
  margin-left: 3rem;
  margin-bottom: 4px;
  line-height: 1.125rem;
  position: relative;
  white-space: normal;
  user-select: none;
  justify-content: flex-start;
  gap: 10px;
  color: #bbb;

  & > p {
    max-width: 75px;
    display: block;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #aaa;
    cursor: pointer;
  }

  &::before {
    --interactive-muted: #555;
    --avatar-size: 40px;
    --gutter: 10px;
    --spine-width: 2px;
    content: "";
    display: block;
    position: absolute;
    box-sizing: border-box;
    top: 50%;
    right: 100%;
    bottom: 0;
    left: calc(var(--avatar-size) / 2 * -1 + var(--gutter) * -1);
    margin-right: 4px;
    margin-top: calc(var(--spine-width) * -1 / 2);
    margin-left: calc(var(--spine-width) * -1 / 2);
    margin-bottom: calc(0.125rem - 4px);
    border-left: var(--spine-width) solid var(--interactive-muted);
    border-bottom: 0 solid var(--interactive-muted);
    border-right: 0 solid var(--interactive-muted);
    border-top: var(--spine-width) solid var(--interactive-muted);
    border-top-left-radius: 6px;
  }
`;
export const ThreadRepliedMessageContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  align-items: center;
  font-size: 0.875rem;
  margin-bottom: 10px;
  line-height: 1.125rem;
  padding: 8px 4px;
  white-space: normal;
  user-select: none;
  justify-content: flex-start;
  color: #bbb;
  border-radius: 5px;
  width: fit-content;
  background: #404040;

  & > p {
    max-width: 50vw;
    display: block;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #bbb;
    cursor: pointer;
    margin: 0 5px 0 0;
  }
`;

export const ThreadMessageContainerArrow = styled.div<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: center;
  font-size: 0.875rem;
  margin-bottom: 4px;
  line-height: 1.125rem;
  position: relative;
  white-space: normal;
  user-select: none;
  justify-content: flex-start;
  gap: 10px;
  color: #bbb;

  & > p {
    max-width: 75px;
    display: block;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #aaa;
    cursor: pointer;
  }

  &::before {
    z-index: 1;
    --interactive-muted: #555;
    --avatar-size: 40px;
    --gutter: -13px;
    --spine-width: 2px;
    content: "";
    display: block;
    position: absolute;
    box-sizing: border-box;
    top: ${({ arrowHeight }) => (arrowHeight ? `${arrowHeight}px` : "0")};
    right: 99%;
    bottom: 50%;
    left: calc(var(--avatar-size) / 2 * -1 + var(--gutter) * -1);
    margin-right: 0px;
    margin-top: ${({ arrowHeight }) => (arrowHeight ? `${-arrowHeight}px` : "0")};
    margin-left: calc(var(--spine-width) * -1 / 2);
    margin-bottom: calc(0.125rem - 4px);
    
    /* Change L-shape to left-bottom */
    border-right: 0;
    border-top: 0;
    border-left: var(--spine-width) solid var(--interactive-muted);
    border-bottom: var(--spine-width) solid var(--interactive-muted);
    
    /* Adjust rounded corner */
    border-bottom-left-radius: 6px;
}
`;

export const RootMessageContainerArrow = styled.div<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: center;
  font-size: 0.875rem;
  margin-bottom: 4px;
  line-height: 1.125rem;
  position: relative;
  white-space: normal;
  user-select: none;
  justify-content: flex-start;
  gap: 10px;
  color: #bbb;

  & > p {
    max-width: 75px;
    display: block;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #aaa;
    cursor: pointer;
  }

  &::before {
    z-index: 1;
    --interactive-muted: #555;
    --avatar-size: 40px;
    --gutter: -13px;
    --spine-width: 2px;
    content: "";
    display: block;
    position: absolute;
    box-sizing: border-box;
    top: ${({ arrowHeight }) => (arrowHeight ? `${arrowHeight}px` : "0")};
    right: 99%;
    bottom: 50%;
    left: calc(var(--avatar-size) / 2 * -1 + var(--gutter) * -1);
    margin-right: -25px;
    margin-top: ${({ arrowHeight }) => (arrowHeight ? `${-arrowHeight}px` : "0")};
    margin-left: 24px;
    margin-bottom: calc(0.125rem - 4px);
    
    /* Change L-shape to left-bottom */
    border-right: 0;
    border-top: 0;
    border-left: var(--spine-width) solid var(--interactive-muted);
    border-bottom: var(--spine-width) solid var(--interactive-muted);
    
    /* Adjust rounded corner */
    border-bottom-left-radius: 6px;
}
`;
export const RepliedMessageContainerReverse = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  align-items: center;
  font-size: 0.875rem;
  margin-right: 3.5rem;
  margin-bottom: 4px;
  line-height: 1.125rem;
  position: relative;
  white-space: normal;
  user-select: none;
  justify-content: flex-start;
  gap: 10px;
  color: #bbb;
  width: -webkit-fill-available;

  & > p {
    max-width: calc(100vw - calc(3.5rem + 165px));
    display: block;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #aaa;
    cursor: pointer;
  }

  &::before {
    --interactive-muted: #555;
    --avatar-size: 40px;
    --gutter: 16px;
    --spine-width: 2px;
    content: "";
    display: block;
    position: absolute;
    box-sizing: border-box;
    top: 50%;
    left: 100%;
    bottom: 0;
    right: calc(var(--avatar-size) / 2 * -1 + var(--gutter) * -1);
    margin-left: 4px;
    margin-top: calc(var(--spine-width) * -1 / 2);
    margin-right: calc(var(--spine-width) * -1 / 2);
    margin-bottom: calc(0.125rem - 4px);
    border-right: var(--spine-width) solid var(--interactive-muted);
    border-bottom: 0 solid var(--interactive-muted);
    border-left: 0 solid var(--interactive-muted);
    border-top: var(--spine-width) solid var(--interactive-muted);
    border-top-right-radius: 6px;
  }
`;

export const RepliedMessageText = styled.div<Props>`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  padding: 2px;
  width: 100%;
`;

export const MessageHeader = styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ContentContainer = styled.div<Props>`
  display: flex;
  padding: 0 10px 0 30px;
`;

export const UserName = styled.div<Props>`
  max-width: 190px;
  display: block;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ ifCurrentUser }) => (ifCurrentUser ? `color: #c8c8c8;` : `color: #aaa;`)}
`;

export const Content = styled.div<Props>`
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin: 0px;
  // align-items: center;
`;

export const ContentText = styled.div<Props>`
  text-align: left;
  white-space: pre-line;
  line-height: 20px;
  word-wrap: anywhere;
  overflow: hidden;
  font-size: 14px;
  ${({ ifFontColor }) =>
    ifFontColor ? `color: ${ifFontColor};` : `color: #222;`}
`;

export const MessageTimeContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 2px 10px;
  margin-top: 2px;
`;

export const EmptyMessageText = styled.div`
  margin-top: 20vh;
  padding: 15px 20px;
  text-align: center;
  font-size: 13px;
  line-height: 30px;
  color: #bbb;
`;

export const EngagementReminders = styled.div`
  margin-top: 30px;
`

export const AssetMessage = styled.div`
  width: 130px;
  padding-left: 5px;
`;

export const AssetMessageImg = styled.img`
  width: 100%;
  border-radius: 10px;
`;

export const ListMessage = styled.div<Props>`
  padding-left: 5px;
  display: flex;
  ${({ isExpired }) =>
    !isExpired
      ? `cursor: pointer;
  &:hover {
    opacity: 0.7;
  }`
      : ""}
`;

export const ListMessageImg = styled.img`
  width: 125px;
  border-radius: 10px 0 0 10px;
`;

export const ListMessageInfo = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #363c47;
  border-radius: 0 10px 10px 0;
  align-items: center;
  padding: 10px;
`;

export const ListMessageInfoItemPrice = styled.div`
  display: flex;
  flex: 3;
  align-items: center;
  font-size: 1.3em;
  font-weight: bold;
  justify-content: center;
`;

export const ListMessageInfoItem = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;
